'use client';

import { useEffect } from 'react';
import { useModerationStore } from '@/store/moderationStore';

// MWBI-666 — fires once on app mount to pull the latest crisis /
// inappropriate word lists from Strapi. Renders nothing. The store is
// fail-open: if the fetch errors, baked-in defaults stay in effect.
export default function ModerationBootstrap() {
  const hydrate = useModerationStore((s) => s.hydrate);
  useEffect(() => {
    void hydrate();
  }, [hydrate]);
  return null;
}
